import { render, staticRenderFns } from "./ContractPortal.vue?vue&type=template&id=13b1e4a6&"
import script from "./ContractPortal.vue?vue&type=script&lang=js&"
export * from "./ContractPortal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/jamievetrovsky/Documents/WorkDevelopment/product-return-portal-fe/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VContainer,VLayout})
